import { ModelBase } from 'store/model-base';
import { OrderProvisioningStatus } from 'my-account/constants';

export class OrderStatus extends ModelBase {
    public static storeName: string = 'orderStatus';

    public orderId: string;
    public orderKey: string;
    public status: string;
    public provisioningStatus: string;
    public errorInfo: errorInfo;
    public additionalInfo: additionalInfo;

    public get isFailed(): boolean {
        return this.provisioningStatus === OrderProvisioningStatus.FAILED;
    }

    public get isCompleted(): boolean {
        return this.provisioningStatus === OrderProvisioningStatus.COMPLETED;
    }
}
